

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import { setCache, setRegisterDetails } from '../../General/Actions.js';
import ProgressBar from 'react-customizable-progressbar';
import Network from '../../Utils/network.js';
import GeneralUtils from '../../Utils/generalUtils.js';
import { Link } from "react-router-dom";
import moment from 'moment';
import Swal from 'sweetalert2';
import SliderModal from '../../Utils/sliderModal.js';
import ValidateForm from '../../Utils/formValidation';
import Constants from '../../Utils/constants.json';

class HomeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            billingName: "",
            contactNumber: "",
            accountId:"",
            connectionType: "",
            maBalance: "0.00",
            serviceId: "",
            isQueryPlanCallRequired: true,
            basePlanDetailsObj: {},
            serviceStatus: "",
            allAddonArray: [],
            isBaseAddonAvailable: false,
            baseAddonObj: {},
            serviceExpiryDateForPrepaid: "",
            isCreditRequestModalVisible: false,
            isCreditTransferModalVisible: false,
            isCallMeBackModalVisible: false,
            callMeBackAllowed: false,
            creditRequestAllowed : false,
            creditTransferAllowed: false,
            creditBalance: 0,
            enableVasFeatures: "false",
            callMeBackStatus: false,
            creditRequestStatus: false,
            balanceTransferStatus: false
        }
    }

    componentDidMount() {
        this.props.setCache("isAddFnFAddon",this.props.feature)
        this.initializeQuerySubscriber()
        var serviceId = "";
        var connectionType = "";
      
        if(this.props.cache && this.props.cache.serviceInfo && this.props.cache.serviceInfo.serviceId && this.props.cache.serviceInfo.connectionType){
            serviceId = this.props.cache.serviceInfo.serviceId;
            connectionType = this.props.cache.serviceInfo.connectionType
        }
       
      
        var serviceTypeTypeArray = [];
        var serviceType = "ALL";
        var selfcareBucketNames = [];
        var enablePayGo = "false";
        var enableVasFeatures = "false";
        Network.executeAxios("checkPaymentDetails", "GET", "", (response) => {
            console.log("checkPaymentDetails >> ", response);
            if (response && response.orderId && response.reason && response.status) {
                var reason = response.reason;
                if (reason == "bill_payment") {
                    reason = "bill";
                } else if (reason == "recharge") {
                    reason = "recharge";
                } else if (reason == "add_addon") {
                    reason = "addon subscription";
                } else if (reason == "change_plan") {
                    reason = "change plan";
                }
                if (response.status === "SUCCESS") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Payment Successful",
                            html: "<div>Your payment for " + reason + " has been successful</div><div style='text-align:center'>Order Id : " + response.orderId + "</div>",
                            type: '',
                            timer: 3000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                        });
                    }, 1000);
                } else if (response.status === "TO_REFUND") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Failed to place the order",
                            html: "<div>Amount debited will be refunded within 2 working days</div>",
                            type: '',
                            timer: 4000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                        });
                    }, 1000);
                } else {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Payment Failed",
                            html: "<div>Your payment for " + reason + " has been Failed</div><div style='text-align:center'>Order Id : " + response.orderId + "</div>",
                            type: '',
                            timer: 3000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                        });
                    }, 1000);
                }
            }
        Network.executeAxios("fetchSelfcareBucketInfo", "POST", {} , (bucketInfoResp) => {
            if(bucketInfoResp && bucketInfoResp[0]) selfcareBucketNames = bucketInfoResp
            if (this.props.configurationValues) {
                serviceTypeTypeArray = this.props.configurationValues.serviceTypeForTransactionHistory
                enablePayGo = this.props.configurationValues.enablePayGo;
                enableVasFeatures = this.props.configurationValues.enableVasFeatures
            }
           
            if(serviceTypeTypeArray && serviceTypeTypeArray.length > 0)
            serviceType = serviceTypeTypeArray[0].id;
            this.initializeUserDetails();
           
            this.setState({
                enablePayGo: enablePayGo,
                enableVasFeatures: enableVasFeatures,
                serviceType: serviceType,
                serviceTypeTypeArray: serviceTypeTypeArray,
                selfcareBucketNames: selfcareBucketNames,
                serviceId: serviceId,
                connectionType: connectionType
            },() => {
                this.loadComponentDidMount();
            });
        })
    })

    }

    loadComponentDidMount() {
        this.state.allServicesCharge = 0;
        this.setState({ isLoading: true })
        this.initialiseSubscriberInfo();

    }

    initializeUserDetails() {
        var reduxCache = this.props.cache;
        try {
            var accountInfo = reduxCache.fetchAccountDetailsResponse;
            var accountInfoParams = accountInfo.BillingSystem.response.dataset.account_info[0];
            var accountBalanceDetails = accountInfoParams.balance_details;

            console.log("fetchAccountDetailsResponse", reduxCache.fetchAccountDetailsResponse)

            this.setState({
                profileId: accountInfoParams.profile_id,
                accountId: accountInfoParams.account_id,
                firstName: accountInfoParams.billing_name,
                lastName: accountInfoParams.last_name,
                emailId: accountInfoParams.notification_email_id,
                billDueDate: GeneralUtils.formatDateToStandardForm(accountBalanceDetails.bill_due_date, this.props.configurationValues.dateFormatForBilling),
                lastPaymentAmount: GeneralUtils.formatNumberToStandardForm(accountBalanceDetails.last_payment_amount,this.props.configurationValues),
                lastPaymentDate: GeneralUtils.formatDateToStandardForm(accountBalanceDetails.last_payment_date, this.props.configurationValues.dateFormatForBilling),
                outstandingAmount: GeneralUtils.formatNumberToStandardForm(accountBalanceDetails.outstanding_balance,this.props.configurationValues),
                billStartDate: GeneralUtils.formatDateToStandardForm(accountBalanceDetails.from_bill_date, this.props.configurationValues.dateFormatForBilling),
                billEndDate: GeneralUtils.formatDateToStandardForm(accountBalanceDetails.to_bill_date, this.props.configurationValues.dateFormatForBilling),
                //creditBalance: GeneralUtils.formatNumberToStandardForm(accountBalanceDetails.total_credit)
            });

            var outstandingAmountFinal = GeneralUtils.formatNumberToStandardForm(accountBalanceDetails.outstanding_balance,this.props.configurationValues)

         
        } catch (err) {

        }
        
        this.setState({ outstandingAmount: outstandingAmountFinal })
    }



    initialiseSubscriberInfo(){
        this.setState({isLoading: true})
        Network.executeAxios("fetchSubscriberInfo", "POST", {"serviceId": this.state.serviceId} , (fetchSubscriberInfoResponse) => {
            this.props.setCache("subscriberInfo", fetchSubscriberInfoResponse);
            var finalDNDStatus = "";
            var maBalance = 0;
            var maBalance_sup = "00";
            var lastRechargeDate = "";
            var accountId = "";
            var payGoStatus = true;
            var serviceStatus = "";
            var creditExpiryDate = "";
            var creditRequestDailyCount = 0;
            var callMeBackDailyCount = 0;
            var balanceTransferDailyCount = 0;
            var callMeBackStatus = false;
            var creditRequestStatus = false;
            var balanceTransferStatus = false;
         
            try {
                var params = fetchSubscriberInfoResponse.service_info.basic_details;
                for(var i=0; i<params.length; i++){
                    if (params[i].id === "callMeBackAllowed" && params[i].value && params[i].value === "true") {
                        callMeBackStatus =true;
                    }
                    if (params[i].id === "creditRequestAllowed" && params[i].value && params[i].value === "true") {
                        creditRequestStatus =true;
                    }
                    if (params[i].id === "balanceTransferAllowed" && params[i].value && params[i].value === "true") {
                        balanceTransferStatus =true;
                    }
                    if (params[i].id === "creditExpiryDate") {
                        creditExpiryDate = params[i].value;
                    }
                    if (params[i].id === "dndStatus") {
                        finalDNDStatus = params[i].value;
                    }
                    if (params[i].id === "payGoFlag") {
                        payGoStatus = params[i].value;
                    }
                    if (params[i].id === "status_value") {
                        serviceStatus = params[i].value;
                    }
                    if (params[i].id === "service_code") {
                        this.state.serviceCode = params[i].value
                    }
                    if (params[i].id === "maBalance") {
                        maBalance = params[i].value
                    }  
                    if (params[i].id === "lastRechargeTime") {
                        lastRechargeDate = params[i].value
                    } 
                    if (params[i].id === "rate_plan_id") {
                        this.state.planId = params[i].value;
                    }
                    if (params[i].id === "fnfAllowed") {
                        this.setState({isFnFAdded: params[i].value})
                    }
                    if (params[i].id === "ocs_status") {
                        this.setState({currentPrepaidStatus: params[i].value})
                    }
                    if (params[i].id === "currentCreditLimit") {
                        this.setState({creditBalance: params[i].value})
                    }
                    if (params[i].id === "account_id") {
                        accountId= params[i].value;
                        this.setState({accountId: params[i].value})
                    }
                    if (params[i].id === "access_type") {
                        this.setState({transportType: params[i].value})
                    }
                    if (params[i].id === "creditRequestDailyCount") {
                        creditRequestDailyCount = params[i].value;
                    }
                    if (params[i].id === "callMeBackDailyCount") {
                        callMeBackDailyCount = params[i].value;
                    }
                    if (params[i].id === "balanceTransferDailyCount") {
                        balanceTransferDailyCount = params[i].value;
                    }
                }
                if (finalDNDStatus === "1") {
                    finalDNDStatus = true;
                } else {
                    finalDNDStatus = false;
                }


                console.log("callMeBackStatus>>>>",callMeBackStatus)
                console.log("creditRequestStatus>>>>",creditRequestStatus)
                console.log("balanceTransferStatus",balanceTransferStatus)
                if(payGoStatus === "true") payGoStatus = true;
                else payGoStatus = false

                this.setState({
                    dndStatus: finalDNDStatus,
                    payGoStatus: payGoStatus,
                    serviceStatus: serviceStatus,
                    creditRequestDailyCount: creditRequestDailyCount,
                    callMeBackDailyCount: callMeBackDailyCount,
                    balanceTransferDailyCount: balanceTransferDailyCount,
                    callMeBackStatus: callMeBackStatus,
                    creditRequestStatus: creditRequestStatus,
                    balanceTransferStatus: balanceTransferStatus
                })

                if(this.state.isPopupVisible){
                    setTimeout(() => {
                        this.setState({ isPopupVisible: false });
                    }, 8000);
                }
            } catch(err){
                console.log("errrrr>>>>",err)
            }

        
            var mainBalanceFormatted = GeneralUtils.formatNumberToStandardForm(maBalance,this.props.configurationValues)
            this.props.setRegisterDetails("generalResponse.maBalance",mainBalanceFormatted)
           
            var callMeBackAllowed = false;
            var creditRequestAllowed = false;
            var creditTransferAllowed = false;
            var  callMeBackBalanceLimit = this.props.configurationValues.callMeBackBalanceLimit;
            var creditRequestBalanceLimit = this.props.configurationValues.creditRequestBalanceLimit;
            var creditTransferLimit = this.props.configurationValues.creditTransferLimit;
            if(callMeBackBalanceLimit && parseFloat(callMeBackBalanceLimit)){
                if(parseFloat(mainBalanceFormatted) <= parseFloat(callMeBackBalanceLimit)) callMeBackAllowed = true;
            } 
            if(creditRequestBalanceLimit && parseFloat(creditRequestBalanceLimit)){
                if(parseFloat(mainBalanceFormatted) <= parseFloat(creditRequestBalanceLimit)) creditRequestAllowed = true;
            } 

            
            if(creditTransferLimit && parseFloat(creditTransferLimit)){
                if(this.props.cache.serviceInfo.connectionType != "1"){
                    if(parseFloat(mainBalanceFormatted) >= parseFloat(creditTransferLimit)) creditTransferAllowed = true;
                } else {
                    if(parseFloat(this.state.creditBalance) >= parseFloat(creditTransferLimit)) creditTransferAllowed = true;
                }
            }         

            if(lastRechargeDate !== ""){
                lastRechargeDate = GeneralUtils.formatDateToStandardForm(lastRechargeDate, this.props.configurationValues.dateFormatForBilling)
            }
            if(creditExpiryDate != ""){
                creditExpiryDate = GeneralUtils.formatDateToStandardForm(creditExpiryDate, this.props.configurationValues.dateFormatForBilling)
            }
            
            this.setState({creditTransferAllowed: creditTransferAllowed, creditRequestAllowed: creditRequestAllowed, callMeBackAllowed: callMeBackAllowed, serviceExpiryDateForPrepaid: creditExpiryDate, maBalance: mainBalanceFormatted, lastRechargeDate: lastRechargeDate})
            if(this.state.isQueryPlanCallRequired){
                var basePlanArr = [];
                Network.executeAxios("queryPlan", "POST", {"serviceId":this.state.serviceId,"serviceCode":this.state.serviceCode, "type": "GSM"} , (queryPlanResponse) => {
                    if(queryPlanResponse && queryPlanResponse.subscriptions && queryPlanResponse.subscriptions[0]){
                        var allSubscriptions = queryPlanResponse.subscriptions;
                        for(var q=0; q<allSubscriptions.length; q++){
                            if(allSubscriptions[q].is_base_plan === "1")
                                basePlanArr.push(allSubscriptions[q])
                           
                        }
                    }
                   
                    this.populateBasePlanDetails(basePlanArr);
                    this.getAllAddons(queryPlanResponse);
                    this.setState({isQueryPlanCallRequired: false, isLoading: false });
            })
            } else {
                this.setState({isLoading: false });
            }
        })
    }

    populateBasePlanDetails(response) {
        var planName = "";
        var planDesc = "";
        var packageAmount = "0";
        var packageAmount_sup = "00";
        var productId = "";
        var planId = "";
        var expiryDate = "NA";
        var activationDate = "NA"
        var isRecurring= true;
        var benefits = [];
        var subscriptionId = "";
        var effectiveDate = "";
        try {
            planName = response[0].plan_name;
            planDesc = response[0].plan_desc;
            productId = response[0].product_id;
            planId = response[0].plan_id;
            subscriptionId = response[0].subscription_id;
            if(response[0] && response[0].expiry_date && response[0].expiry_date !== "")
                expiryDate = GeneralUtils.formatDateToStandardForm(response[0].expiry_date, this.props.configurationValues.dateFormatForBilling)
            if(response[0] && response[0].activation_date && response[0].activation_date !== "")
                activationDate = GeneralUtils.formatDateToStandardForm(response[0].activation_date, this.props.configurationValues.dateFormatForBilling)
            var packageAmount = 0;
            var packageAmount_sup = 0;
            var basePlanPrice = 0;
            var discountPrice = 0;
            var discountName = "Discount"

            if(this.props.cache.serviceInfo.connectionType != "1"){
                effectiveDate = response[0].effective_date;
            } 


            try {
                var currentSubscription = response[0].subscription_charges
                this.state.basePlanArray = currentSubscription

                for (var i = 0; i < currentSubscription.length; i++) {
                    var currentChargeData = currentSubscription[i]
                    if (currentChargeData.charge_category === "2" || currentChargeData.charge_category === "1") {
                        basePlanPrice = currentChargeData.charge_amount;
                        if(currentChargeData.charge_type === "1") isRecurring =false;
                    }
                    if (currentChargeData.charge_category === "5" && currentChargeData.discount_type === "F") {
                        discountPrice = currentChargeData.discount_value
                        discountName = currentChargeData.discount_name
                    } else if (currentChargeData.charge_category === "5" && currentChargeData.discount_type === "P") {
                        discountPrice = ((parseFloat(basePlanPrice) * parseFloat(currentChargeData.discount_value)) / 100);
                        discountName = currentChargeData.discount_name
                    }
                }
            }
            catch (err) {

            }
            this.state.allServicesCharge = (parseFloat(this.state.allServicesCharge) + parseFloat(basePlanPrice)) - parseFloat(discountPrice)
            var Price = GeneralUtils.formatNumberToStandardForm(this.state.allServicesCharge,this.props.configurationValues)
            Price = Price.split(".");
            packageAmount = Price[0]
            if (Price.length > 1) {
                packageAmount_sup = Price[1];
            } else {
                packageAmount_sup = "00"
            }

        } catch (err) {
            planName = "";
            planDesc = "";
        }
        var subscription = {}
        try {
            subscription = response[0]
            subscription.subscription_charges = subscription.charges;
            delete subscription.charges;
        } catch {

        }

        if(response && response[0] && response[0].benefits){
            var benefitArr = response[0].benefits;
            benefitArr = benefitArr.sort((a, b) => {
                if (a.is_carry_forward === b.is_carry_forward) {
                    return 0;
                }
                return a.is_carry_forward === 'true' ? 1 : -1;
            });

          
           
            for(var y=0; y< benefitArr.length; y++){
                var benefitObj = benefitArr[y];
                if(benefitObj && benefitObj.initial_value){
                    var temp = {
                        val: benefitObj.value,
                        initialVal: benefitObj.initial_value || 0,
                        unit: benefitObj.unit_type,
                        usageName: benefitObj.name || "NA",
                        expiryDate: benefitObj.expiry_date,
                        isCarryForward: benefitObj.is_carry_forward|| "false"
                     }
                     if(benefitObj.unit_type === "Seconds"){
                        var currentVal=benefitObj.value;
                        currentVal = parseFloat(currentVal)/60;
                        var initialVal= benefitObj.initial_value;
                        initialVal=parseFloat(initialVal)/60;
                        temp["val"] = currentVal.toFixed(2);
                        temp["initialVal"] = initialVal.toFixed(2);
                        temp["unit"] = "Minutes";
                     }
                     if(benefitObj.unit_type === "Bytes"){
                        var currentVal=benefitObj.value;
                        currentVal = parseFloat(currentVal)/1048576;
                        var initialVal= benefitObj.initial_value;
                        initialVal=parseFloat(initialVal)/1048576;
                        temp["val"] = currentVal.toFixed(2);
                        temp["initialVal"] = initialVal.toFixed(2);
                        temp["unit"] = "MB";
                     }
                     benefits.push(temp)
                }
            }
        }

        var temp = {
            activePlanName: planName,
            activePlanDesc: planDesc,
            activePlanAmount: packageAmount,
            activePlanDecimal: packageAmount_sup,
            discountAmount: GeneralUtils.formatNumberToStandardForm(discountPrice,this.props.configurationValues),
            discountName: discountName,
            basePlanPrice: GeneralUtils.formatNumberToStandardForm(basePlanPrice,this.props.configurationValues),
            allBasePlanServiceCharge: this.state.allServicesCharge,
            subscription: subscription,
            serviceId: this.props.cache.serviceInfo.serviceId,
            productId: productId,
            contractId: this.state.contractId,
            serviceName: this.props.cache.serviceInfo.serviceName,
            serviceCode: this.props.cache.serviceInfo.networkType,
            planId: planId,
            connectionType: this.props.cache.serviceInfo.connectionType,
            isRecurring: isRecurring,
            taxArray: [],
            discountArray: [],
            subscriptionId: subscriptionId,
            effectiveDate: effectiveDate
        }
        this.props.setCache("currentPlanDetails", temp);

        var activeBasePlanDetailsObj = {
            planId: planId,
            activePlanName: planName,
            activePlanDesc: planDesc,
            activePlanAmount: packageAmount,
            activePlanDecimal:  packageAmount_sup,
            discountAmount: GeneralUtils.formatNumberToStandardForm(discountPrice,this.props.configurationValues),
            discountName: discountName,
            basePlanPrice: GeneralUtils.formatNumberToStandardForm(basePlanPrice,this.props.configurationValues),
            postpaidExpiryDate: expiryDate,
            activationDate: activationDate,
            isRecurring: isRecurring,
            benefits: benefits,
            effectiveDate: effectiveDate
        }
       
        this.setState({basePlanDetailsObj: activeBasePlanDetailsObj})
        console.log("ACTIVE PLAN DETAILS >>>",activeBasePlanDetailsObj)
        this.state.currentService = [
            {
                "currentPlanName": planName,
                "subscriptions": response.subscriptions
            }
        ]

        this.props.setRegisterDetails("services", this.state.currentService);

    }

    getAllAddons(receivedResponse) {
        var receivedResponse = receivedResponse.subscriptions
        var allAddonArray = []
        var planIdForFnF = ""
        var activationDate = ""
        var addonExpiryDate = ""
        var baseAddonObj = {};
        var isBaseAddonAvailable= false;
       
        var changeBaseAddonData = {
            "linkedPlanId": this.state.basePlanDetailsObj.planId,
            "planId": "",
            "subscriptionId": ""
        }

        try {

            for (var i = 0; i < receivedResponse.length; i++) {
                var currentAddon = receivedResponse[i];
                var totalDiscountPrice = "0";
                var totalAddOnTaxPrice = 0;
                var totalAddonAmount = "0.00"
                var effectiveDate = "";

                if(this.props.cache.serviceInfo.connectionType != "1"){
                    effectiveDate = currentAddon.effective_date;
                } 



                var benefits = [];
                
                if (currentAddon.is_base_plan === "0" && currentAddon.subscription_type === "0") {
                    var todayDate = moment();
                    var expiryDate = moment(currentAddon.expiry_date, "MM/DD/YYYY HH:mm:ss", "MM-DD-YYYY");
                    var dDiff = expiryDate.diff(todayDate, 'seconds');
                    if (dDiff > 0) {
                        if(currentAddon.linked_plan_id === this.state.basePlanDetailsObj.planId){
                            changeBaseAddonData = {
                                "planId": currentAddon.plan_id,
                                "subscriptionId": currentAddon.subscription_id,
                                "linkedPlanId": this.state.basePlanDetailsObj.planId
                            }
                            isBaseAddonAvailable = true;
                        }
                        if (currentAddon && currentAddon.ocs_plan_type && currentAddon.ocs_plan_type.toUpperCase() === "FNF") {
                            planIdForFnF = currentAddon.plan_id;
                          
                        }
                        addonExpiryDate = GeneralUtils.formatDateToStandardForm(currentAddon.expiry_date, "MM/DD/YYYY HH:mm:ss", "MM/DD/YYYY");
                        activationDate = GeneralUtils.formatDateToStandardForm(currentAddon.activation_date, "MM/DD/YYYY HH:mm:ss", "MM/DD/YYYY");

                        var tierBasedAddonPrice = "0.00";
                        for(var y=0; y<currentAddon.subscription_charges.length; y++){
                            var currentBasePriceObj = currentAddon.subscription_charges[y];
                            
                            if(currentBasePriceObj.charge_category && currentBasePriceObj.charge_category === "1")
                            tierBasedAddonPrice = currentBasePriceObj.charge_amount
                        }

                        try{
                        for(var x=0; x< currentAddon.subscription_charges.length; x++){
                            var currentPriceObj = currentAddon.subscription_charges[x];
                          
                
                            if(currentPriceObj.charge_category && currentPriceObj.charge_category == this.props.locales.priceCategoryForDiscount && !isNaN(parseFloat(currentPriceObj.charge_amount))){
                                var discountPrice = "0.00";
                                
                                if(currentPriceObj.charge_type == this.props.locales.PriceTypeForPercentage){
                                    discountPrice = parseFloat((parseFloat(tierBasedAddonPrice).toFixed(2) * (parseFloat(currentPriceObj.charge_amount)).toFixed(2))/100).toFixed(2);
                                } else{
                                    discountPrice = (parseFloat(currentPriceObj.charge_amount)).toFixed(2);
                                }
                                
                                totalDiscountPrice = parseFloat(totalDiscountPrice) + parseFloat(discountPrice);
                                
                            }
                        
                       
                    
                        var basePriceAfterDiscount  =  parseFloat(tierBasedAddonPrice).toFixed(2) - parseFloat(totalDiscountPrice).toFixed(2);
            
                        //For Tax 
                        var addOnTaxPrice = 0;
                        if(currentPriceObj && currentPriceObj.charge_category && currentPriceObj.charge_category === "6" && !isNaN(parseFloat(currentPriceObj.charge_amount))){  
                            if(currentPriceObj.charge_type!=null && currentPriceObj.charge_type === "1"){
                                addOnTaxPrice = (parseFloat(basePriceAfterDiscount).toFixed(2) * (parseFloat(currentPriceObj.charge_amount)).toFixed(2)/100).toFixed(2);
                                totalAddOnTaxPrice += addOnTaxPrice
                            }else{
                                addOnTaxPrice = (parseFloat(currentPriceObj.charge_amount)).toFixed(2);
                                totalAddOnTaxPrice += addOnTaxPrice
                            } 
                        }
                    }
                
            
                  totalAddonAmount = basePriceAfterDiscount + parseFloat(totalAddOnTaxPrice)
                  totalAddonAmount = parseFloat(totalAddonAmount).toFixed(2)
                   
                } catch(err){
                    console.log("error>>>>>>>",err)
                }

                        if (currentAddon && currentAddon.benefits) {
                            var benefitArr = currentAddon.benefits

                            benefitArr = benefitArr.sort((a, b) => {
                                if (a.is_carry_forward === b.is_carry_forward) {
                                    return 0;
                                }
                                return a.is_carry_forward === 'true' ? 1 : -1;
                            });

                            for (var y = 0; y < benefitArr.length; y++) {
                                var benefitObj = benefitArr[y];
                                var temp = {
                                    val: benefitObj.value,
                                    initialVal: benefitObj.initial_value || 0,
                                    unit: benefitObj.unit_type,
                                    usageName: benefitObj.name || "NA"     ,
                                    isCarryForward: benefitObj.is_carry_forward || "false",
                                    expiryDate: benefitObj.expiry_date                 
                                 }
                                 if(benefitObj.unit_type === "Seconds"){
                                    var currentVal=benefitObj.value;
                                    currentVal = parseFloat(currentVal)/60;
                                    var initialVal= benefitObj.initial_value;
                                    initialVal=parseFloat(initialVal)/60;
                                    temp["val"] = currentVal.toFixed(2);
                                    temp["initialVal"] = initialVal.toFixed(2);
                                    temp["unit"] = "Minutes";
                                 }
                                 if(benefitObj.unit_type === "Bytes"){
                                    var currentVal=benefitObj.value;
                                    currentVal = parseFloat(currentVal)/1048576;
                                    var initialVal= benefitObj.initial_value;
                                    initialVal=parseFloat(initialVal)/1048576;
                                    temp["val"] = currentVal.toFixed(2);
                                    temp["initialVal"] = initialVal.toFixed(2);
                                    temp["unit"] = "MB";
                                 }
                                benefits.push(temp)
                            }
                        }

                        if (currentAddon.linked_plan_id === "") {
                            var isRecurring = true;
                            let temp = {
                                "addonName": currentAddon.plan_name,
                                "addonDesc": currentAddon.plan_desc,
                                "addonPrice": totalAddonAmount,
                                "planId": currentAddon.plan_id,
                                "subscription_charges": currentAddon.subscription_charges,
                                "isIncluded": false,
                                "benefits": benefits,
                                "expiryDate": addonExpiryDate,
                                "activationDate": activationDate,
                                "effectiveDate": effectiveDate
                            }
                            if (currentAddon.subscription_charges && currentAddon.subscription_charges[0] && currentAddon.subscription_charges[0].charge_type === "1") isRecurring = false;
                            temp["isRecurring"] = isRecurring
                            allAddonArray.push(temp)
                        } else {
                            var isRecurring = true;
                            let temp = {
                                "addonName": currentAddon.plan_name,
                                "addonDesc": currentAddon.plan_desc,
                                "addonPrice": totalAddonAmount,
                                "planId": currentAddon.plan_id,
                               // "subscription_charges": currentAddon.subscription_charges,
                                "isIncluded": true,
                                "benefits": benefits,
                                "expiryDate": addonExpiryDate,
                                "activationDate": activationDate,
                                "effectiveDate": effectiveDate
                            }
                            if (currentAddon.subscription_charges && currentAddon.subscription_charges[0] && currentAddon.subscription_charges[0].charge_type === "1") isRecurring = false;
                            temp["isRecurring"] = isRecurring
                            if(isBaseAddonAvailable){
                                allAddonArray.forEach(addon => {
                                    if (addon.isBaseAddon === "true") {
                                        addon.isBaseAddon = "false"; // Set existing base addon's isBaseAddon to false
                                    }
                                });
                            
                                // Create and add new base addon
                                baseAddonObj = temp;
                                temp["isBaseAddon"] = "true";
                                allAddonArray.push(temp);
                            } else {
                                temp["isBaseAddon"] = "false";
                                allAddonArray.push(temp)
                            }
                            this.state.allServicesCharge = this.state.allServicesCharge + parseFloat(totalAddonAmount)
                       
                        }
                    }
                }
            }
        } catch (err) {
            console.log("errrrrrrrrrrrrrr",err)
           
        }

        const addonFilteredArray = allAddonArray.filter(obj => obj.isBaseAddon !== "true")

        let fnfData = {
            "isFnFAdded": this.state.isFnFAdded,
            "planIdForFnF": planIdForFnF,
            "activationDateForFnF": activationDate,
            "serviceAddress": {},
            "currentService": this.state.currentService, 
            "allAddonArray": addonFilteredArray,
            "addonExpiryDate": addonExpiryDate,
            "serviceId": this.props.cache.serviceInfo.serviceId
        }

        changeBaseAddonData["isBaseAddonAvailable"] = isBaseAddonAvailable;
        changeBaseAddonData["baseAddonObj"] = baseAddonObj;

        this.props.setRegisterDetails("isFnFAdded", this.state.isFnFAdded)

        this.props.setRegisterDetails("activeAddons", addonFilteredArray)
        this.props.setRegisterDetails("generalResponse.changeBaseAddonData", changeBaseAddonData)
        this.props.setRegisterDetails("generalResponse.fnfData", fnfData)

       
        console.log("BASE ADDON DETAILS => ",baseAddonObj)
        console.log("isBaseAddonAvailable => ",isBaseAddonAvailable)

        console.log("allAddon Details>>>>", addonFilteredArray)
        this.setState({isBaseAddonAvailable: isBaseAddonAvailable, baseAddonObj: baseAddonObj, addonExpiryDate: addonExpiryDate, allAddonArray: addonFilteredArray, isLoading: false })
    }



    initializeQuerySubscriber() {
        var receivedResponse= this.props.cache.querySubscriberResponse;
        var params = [];
        try {
            params = receivedResponse.profile_info.basic_details;
        } catch (err) {
            params = [];
        }

        var firstName = "";
        var lastName = "";
        var finalContactNumber = "";
        for (var i = 0; i < params.length; i++) {
            if (params[i].id  === "first_name") {
                firstName = params[i].value;
            }
            if (params[i].id  === "last_name") {
                lastName = params[i].value;
            }
            if (params[i].id  === "contact_number_1") {
                finalContactNumber = params[i].value;
            }
        }
        this.setState({
            billingName: firstName+" "+lastName,
            contactNumber: finalContactNumber
        });
    }


       callMeBackModalHandler = (dataObject) => {
            if (dataObject.type === "cancel") {
                document.body.classList.remove('modal-open');
                this.setState({destinationServiceId: "", isCallMeBackModalVisible: false })
            } else if (dataObject.type === "submit") {
                if (ValidateForm.inputFieldMandatoryCheck("callMeBackContainer", this.props.locales, false)) {
                    if (ValidateForm.inputFieldValueCompositionCheck("callMeBackContainer", this.props.locales, false)) {
                        document.body.classList.remove('modal-open');
                        
                        var mobileNum = this.state.destinationServiceId.replace(/\D/g, "");
                        console.log("mobileNum",mobileNum)
                        console.log("mobileNumlen",mobileNum.length)
                        if(mobileNum.length < parseInt(this.props.locales.minLengthForCallMeNumber)){
                            Swal.fire(this.props.locales.enterProperDestServiceIdCallMeBackSwalMsg)
                        } else if(this.state.serviceId === mobileNum){
                            Swal.fire(this.props.locales.enterDifferentServiceIdSwalMsg)
                        } else {
                            this.setState({ isLoading: true })
                            //Network.executeAxios("fetchSubscriberInfo", "POST", {"serviceId": mobileNum} , (fetchSubscriberInfoResponse) => {
                                var isValidNumber = true;
                                // if(fetchSubscriberInfoResponse && fetchSubscriberInfoResponse.service_info && fetchSubscriberInfoResponse.service_info.basic_details  && fetchSubscriberInfoResponse.service_info.basic_details[0]){
                                //     // var params = fetchSubscriberInfoResponse.service_info.basic_details;
                                //     // for(var i=0; i<params.length; i++){
                                //     //     if (params[i].id === "ocs_status") {
                                //     //         ocsStatus = params[i].value
                                //     //     }
                                //     // }
                                //     isValidNumber = true;
                                // }
                                if(isValidNumber){
                                    var dataToSend = {
                                        "accountId": this.state.accountId,
                                        "profileId": this.state.profileId,
                                        "customerName": this.state.billingName,
                                        "externalServiceId": this.state.serviceId,
                                        "internalServiceId": "",
                                        "destinationServiceId":  mobileNum,
                                        "contactNum": this.state.contactNumber
                                    }
                                
                                    Network.executeAxios("callMeBack", "POST", dataToSend , (response) => {
                                        this.setState({ isCallMeBackModalVisible: false, destinationServiceId: "" });
                                        if(response && response.dataset && response.dataset && response.dataset.param && response.dataset.param[0] && response.dataset.param[0].id  && response.dataset.param[0].id === "order_id" && response.dataset.param[0].value  && response.dataset.param[0].value !== ""){
                                             this.setState({destinationServiceId: ""})   
                                            Swal.fire({
                                                    title: this.props.locales.callMebackSuccessSwalText.replace('{{number}}', mobileNum),
                                                    text: '',
                                                    type: '',
                                                    showCancelButton: false,
                                                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                                                }).then((result) => {
                                                    document.body.classList.remove('modal-open');
                                                    this.initialiseSubscriberInfo()
                                                });
                                        } else {
                                            this.setState({isLoading: false})
                                            Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "");
                                        }
                                    })
                                } else {
                                    this.setState({ isLoading: false })
                                    Swal.fire(this.props.locales.enterProperDestServiceIdCallMeBackSwalMsg)
                                }
                           // })
                        }
                    }
                }
            }
        }


        creditTransferModalHandler = (dataObject) => {
            if (dataObject.type === "cancel") {
                document.body.classList.remove('modal-open');
                this.setState({ isCreditTransferModalVisible: false })
            } else if (dataObject.type === "submit") {
                if (ValidateForm.inputFieldMandatoryCheck("creditTransferContainer", this.props.locales, false)) {
                    if (ValidateForm.inputFieldValueCompositionCheck("creditTransferContainer", this.props.locales, false)) {
                        document.body.classList.remove('modal-open');
                        this.setState({ isLoading: true })
                        var destinationServiceId = this.props.configurationValues.dialCode + this.state.destinationServiceId.replace(/\D/g, "");
                        var mobileNum = "1"+this.props.configurationValues.dialCode + this.state.destinationServiceId.replace(/\D/g, "");

                        if(this.state.connectionType !== "1" && (parseFloat(this.state.maBalance) < parseFloat(this.state.amount))) {
                            Swal.fire(this.props.locales.mainBalanceLessToProceedSwalMsg);
                            this.setState({isLoading: false})
                            return;
                        } 

                        if(this.state.connectionType === "1" && (parseFloat(this.state.creditBalance) < parseFloat(this.state.amount))) {
                            Swal.fire(this.props.locales.creditBalanceLessToProceedSwalMsg);
                            this.setState({isLoading: false})
                            return;
                        } 

                        if(this.state.serviceId === mobileNum){
                            this.setState({ isLoading: false })
                            Swal.fire(this.props.locales.enterDifferentServiceIdSwalMsg)
                        } else {
                            var minimumCreditTransferAmount = this.props.configurationValues.minimumCreditTransferAmount;
                            var maximumCreditTransferAmount = this.props.configurationValues.maximumCreditTransferAmount;
                            
                            if(parseFloat(this.state.amount) >= parseFloat(minimumCreditTransferAmount) && parseFloat(this.state.amount) <= parseFloat(maximumCreditTransferAmount)){
                                Network.executeAxios("fetchSubscriberInfo", "POST", {"serviceId": mobileNum} , (fetchSubscriberInfoResponse) => {
                                    var isValidNumber = false;
                                    var ocsStatus = "NA";
                                    var bPartyConnectionType = "1"
                                    if(fetchSubscriberInfoResponse && fetchSubscriberInfoResponse.service_info && fetchSubscriberInfoResponse.service_info.basic_details  && fetchSubscriberInfoResponse.service_info.basic_details[0]){
                                        var params = fetchSubscriberInfoResponse.service_info.basic_details;
                                        for(var i=0; i<params.length; i++){
                                            if (params[i].id === "ocs_status") {
                                                ocsStatus = params[i].value
                                            }
                                
                                            if (params[i].id === "connection_type") {
                                                bPartyConnectionType = params[i].value
                                            }
                                        }
                                    }
                                if(bPartyConnectionType !== "1") {
                                    const allowedOcsStatusForCreditTransfer = this.props.configurationValues.allowedOcsStatusForCreditTransfer;
                                   
                                    const allowedStatuses = allowedOcsStatusForCreditTransfer
                                    .split(',')
                                    .map(status => status.toUpperCase());
                                   
                                    if (allowedStatuses.includes(ocsStatus.toUpperCase())) {
                                        isValidNumber = true;
                                    }
                                }


                                if(isValidNumber){
                                    var balanceTrasferFee =  this.props.configurationValues.balanceTrasferFee;
                                    Swal.fire({
                                        title: "Please confirm credit transfer of $"+this.state.amount+" to "+destinationServiceId,
                                        text: '',
                                        type: '',
                                        showCancelButton: true,
                                        confirmButtonText: 'OK',
                                        cancelButtonText: 'Cancel',
                                        reverseButtons: true
                                    }).then((result) => {
                                        if (result.value) { 
                                            var dataToSend = {
                                                "accountId": this.state.accountId,
                                                "profileId": this.state.profileId,
                                                "customerName": this.state.billingName,
                                                "externalServiceId": this.state.serviceId,
                                                "internalServiceId": "",
                                                "destinationServiceId":  mobileNum,
                                                "amount": parseFloat(this.state.amount) + parseFloat(balanceTrasferFee),
                                                "contactNum": this.state.contactNumber
                                            }
                                       
                                            Network.executeAxios("creditTransfer", "POST", dataToSend , (response) => {
        
                                                if(response && response.dataset && response.dataset && response.dataset.param && response.dataset.param[0] && response.dataset.param[0].id  && response.dataset.param[0].id === "order_id" && response.dataset.param[0].value  && response.dataset.param[0].value !== ""){
                                                        Swal.fire({
                                                            title: this.props.locales.creditTransferSuccessSwalText+" $"+this.state.amount+" was sent to "+destinationServiceId,
                                                            text: '',
                                                            type: '',
                                                            showCancelButton: false,
                                                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                                                        }).then((result) => {
                                                            this.initialiseSubscriberInfo();
                                                            document.body.classList.remove('modal-open');
                                                        });
                                                } else {
                                                    this.setState({isLoading: false})
                                                    Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "");
                                                }
                                                this.setState({ isCreditTransferModalVisible: false, destinationServiceId: "", amount: "", isLoading: false });
                                            })
                                        } else{
                                            this.setState({ isLoading: false });
                                        }
                                    });
                                } else {
                                    this.setState({ isLoading: false })
                                    Swal.fire(this.props.locales.enterProperDestServiceIdSwalMsg)
                                }
                                
                            })
                        } else {
                            this.setState({ isLoading: false })
                            Swal.fire("Please select a value between $"+minimumCreditTransferAmount+" - $"+maximumCreditTransferAmount+".")
                        }

                        }
    
                    }
                }
            }
        }

        creditRequestModalHandler = (dataObject) => {
            if (dataObject.type === "cancel") {
                document.body.classList.remove('modal-open');
                this.setState({ isCreditRequestModalVisible: false })
            } else if (dataObject.type === "submit") {
                if (ValidateForm.inputFieldMandatoryCheck("creditRequestContainer", this.props.locales, false)) {
                    if (ValidateForm.inputFieldValueCompositionCheck("creditRequestContainer", this.props.locales, false)) {
                        document.body.classList.remove('modal-open');
                        this.setState({ isLoading: true })
                        var destinationServiceId = this.props.configurationValues.dialCode + this.state.destinationServiceId.replace(/\D/g, "");
                        var mobileNum = "1"+this.props.configurationValues.dialCode + this.state.destinationServiceId.replace(/\D/g, "");
                        if(this.state.serviceId === mobileNum){
                            this.setState({ isLoading: false })
                            Swal.fire(this.props.locales.enterDifferentServiceIdSwalMsg)
                        } else {
                            var minimumCreditRequestAmount = this.props.configurationValues.minimumCreditRequestAmount;
                            var maximumCreditRequestAmount = this.props.configurationValues.maximumCreditRequestAmount;
                            
                            if(parseFloat(this.state.amount) >= parseFloat(minimumCreditRequestAmount) && parseFloat(this.state.amount) <= parseFloat(maximumCreditRequestAmount)){
                                Network.executeAxios("fetchSubscriberInfo", "POST", {"serviceId": mobileNum} , (fetchSubscriberInfoResponse) => {
                                    var isValidNumber = false;
                                    if(fetchSubscriberInfoResponse && fetchSubscriberInfoResponse.service_info && fetchSubscriberInfoResponse.service_info.basic_details  && fetchSubscriberInfoResponse.service_info.basic_details[0]){
                                        // var params = fetchSubscriberInfoResponse.service_info.basic_details;
                                        // for(var i=0; i<params.length; i++){
                                        //     if (params[i].id === "ocs_status") {
                                        //         ocsStatus = params[i].value
                                        //     }
                                        // }
                                        isValidNumber = true;
                                    }
    
                                if(isValidNumber){
                                    var dataToSend = {
                                        "accountId": this.state.accountId,
                                        "profileId": this.state.profileId,
                                        "customerName": this.state.billingName,
                                        "externalServiceId": this.state.serviceId,
                                        "internalServiceId": "",
                                        "destinationServiceId":  mobileNum,
                                        "amount": this.state.amount,
                                        "contactNum": this.state.contactNumber
                                    }
                                   
                                    Network.executeAxios("creditRequest", "POST", dataToSend , (response) => {
                                        if(response && response.dataset && response.dataset && response.dataset.param && response.dataset.param[0] && response.dataset.param[0].id  && response.dataset.param[0].id === "order_id" && response.dataset.param[0].value  && response.dataset.param[0].value !== ""){
                                                Swal.fire({
                                                    title: this.props.locales.creditRequestSuccessSwalText.replace('{{number}}', destinationServiceId),
                                                    text: '',
                                                    type: '',
                                                    showCancelButton: false,
                                                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                                                }).then((result) => {
                                                    this.initialiseSubscriberInfo()
                                                    document.body.classList.remove('modal-open');
                                                });
                                        } else {
                                            this.setState({isLoading: false})
                                            Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "");
                                        }
                                    })
                                } else {
                                    this.setState({ isLoading: false })
                                    Swal.fire(this.props.locales.enterProperDestServiceIdSwalMsg)
                                }
                                this.setState({ isCreditRequestModalVisible: false, destinationServiceId: "", amount: "", isLoading: false });
                            })
                            } else {
                                this.setState({ isLoading: false })
                                Swal.fire("Please select a value between $"+minimumCreditRequestAmount+" - $"+maximumCreditRequestAmount+".")
                            }
                        }
                    }
                }
            }
        }
    
    handleInputValueChange(name, event) {
        const validated = event.match(/^(\d*\.{0,1}\d{0,2}$)/)
        if(validated){
            this.state[name] = event;
            this.setState({ dummy: "dummy" })
        }
    };

    render() {
        return (
            <div className="col-md-12 animated fadeIn justify-content-center p-0 m-0">
                {this.state.isLoading  === true ? <LoadingAnimation isVisible={true} /> : 
                (<div className='align-items-center' id="HomeComponentContainer">
                    {this.renderHomeContentPart()}
                </div>)}  
            </div>
        );
    }

    renderHomeContentPart() {
        return (
        <div className='col-md-12 d-flex justify-content-center'>
            <div className='col-md-11 row justify-content-center m-0 p-0'>
                <div className='col-md-4 col-sm-12 mb-3'>
                    {this.myPlanCard()}
                </div>
                <div className='col-md-4 col-sm-12 mb-3'>
                    {this.addonCard()}
                </div>
                <div className='col-md-4 col-sm-12 mb-3'>
                    {this.moreFeturesCard()}
                </div>
            </div>

            {/* call me back */}
            <SliderModal
                    isVisible={this.state.isCallMeBackModalVisible}
                    uniqueModalReferenceId="callMeBack"
                    mainHeading={this.props.locales.mainHeadingInCallMeBackModal}
                    isResetButtonVisible={false}
                    leftPartFlexValue={1.5}
                    rightPartFlexValue={1}
                    submitButtonText="Submit"
                    callback={this.callMeBackModalHandler}
                >
                    <div className="col-md-12 px-2" style={{ height: '100%' }} id="callMeBackContainer">
                        <div className="col-md-12 pt-3">
                            <div className="form-group col-md-8 p-0 mb-1">
                                <label className="formGroup_label_new">{this.props.locales.callMeSliderLabelMsg}</label>
                                {/* <div className="form-group float-left p-0" style={{ width: 64 }}>
                                    <input className="form-control formGroup_value_ mandatoryField_ input_data_" style={{ borderLeft: '3px solid #EE3124', borderTopRightRadius: 0, borderBottomRightRadius: 0, backgroundColor: '#eaedf0' }}
                                        value={this.props.configurationValues.dialCode} disabled />
                                </div> */}

                                <div className="d-flex flex-column form-group">
                                    <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data"
                                        value={this.state.destinationServiceId} maxLength={this.props.locales.maxLengthForCallMeNumber} minLength={this.props.locales.minLengthForCallMeNumber}
                                        onChange={(event) => {
                                            this.handleInputValueChange("destinationServiceId", event.target.value)
                                        }}
                                    />
                                    <div className="errorDesc"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                </SliderModal>


                {/* credit transfer */}
                <SliderModal
                    isVisible={this.state.isCreditTransferModalVisible}
                    uniqueModalReferenceId="creditTransfer"
                    mainHeading={this.props.locales.mainHeadingInCreditTransferModal}
                    isResetButtonVisible={false}
                    leftPartFlexValue={1.5}
                    rightPartFlexValue={1}
                    submitButtonText="Submit"
                    callback={this.creditTransferModalHandler}
                >
                    <div className="col-md-12 px-2" style={{ height: '100%' }} id="creditTransferContainer">
                        <div className="col-md-8 pt-3">
                            <div className="form-group col-md-12 p-0 mb-1">
                                <label className="formGroup_label_new">{this.props.locales.creditTransferSliderLabelMsg}</label>
                                <div className="form-group float-left p-0" style={{ width: 64 }}>
                                    <input className="form-control formGroup_value_ mandatoryField_ input_data_" style={{ borderLeft: '3px solid #EE3124', borderTopRightRadius: 0, borderBottomRightRadius: 0, backgroundColor: '#eaedf0' }}
                                        value={this.props.configurationValues.dialCode} disabled />
                                </div>
                                <div className="d-flex flex-column form-group">
                                    <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data"
                                        value={this.state.destinationServiceId}
                                        maxLength={7}
                                        onChange={(event) => {
                                            this.handleInputValueChange("destinationServiceId", event.target.value)
                                        }}
                                    />
                                     <div className="errorDesc"></div>
                                </div>
                               
                            </div>

                            <div className="form-group col-md-12 p-0 mb-1">
                                <label className="formGroup_label_new">{this.props.locales.enterAmountInCreditTransferModal}</label>
                                <div className="form-group float-left p-0" style={{ width: 64 }}>
                                    <input className="form-control formGroup_value_ mandatoryField_ input_data_" style={{textAlign: 'center', borderLeft: '3px solid #EE3124', borderTopRightRadius: 0, borderBottomRightRadius: 0, backgroundColor: '#eaedf0' }}
                                        value={Constants.dollarSign} disabled />
                                </div>
                                <div className="d-flex flex-column form-group">
                                    <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data typeVasAmount"
                                        value={this.state.amount}
                                        onChange={(event) => {
                                            this.handleInputValueChange("amount", event.target.value)
                                        }}
                                    />
                                     <div className="errorDesc"></div>
                                </div>
                               
                            </div>
                        </div>
                        {this.state.connectionType === "1" ? 
                        <div className='col-md-12 pt-3' style={{fontSize: 14}}>{this.props.locales.currentCreditLimitMsgInCreditTransfer} : ${this.state.creditBalance}</div>
                        : null }
                    </div>

                </SliderModal>


                {/* credit request */}
                <SliderModal
                    isVisible={this.state.isCreditRequestModalVisible}
                    uniqueModalReferenceId="creditRequest"
                    mainHeading={this.props.locales.mainHeadingInCreditRequestModal}
                    isResetButtonVisible={false}
                    leftPartFlexValue={1.5}
                    rightPartFlexValue={1}
                    submitButtonText="Request"
                    callback={this.creditRequestModalHandler}
                >
                    <div className="col-md-12 px-2" style={{ height: '100%' }} id="creditRequestContainer">
                        <div className="col-md-12 pt-3">
                            <div className="form-group col-md-8 p-0 mb-1">
                                <label className="formGroup_label_new">{this.props.locales.creditRequestSliderLabelMsg}</label>
                                <div className="form-group float-left p-0" style={{ width: 64 }}>
                                    <input className="form-control formGroup_value_ mandatoryField_ input_data_" style={{ borderLeft: '3px solid #EE3124', borderTopRightRadius: 0, borderBottomRightRadius: 0, backgroundColor: '#eaedf0' }}
                                        value={this.props.configurationValues.dialCode} disabled />
                                </div>
                                <div className="d-flex flex-column form-group">
                                    <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data"
                                        maxLength={7}
                                        value={this.state.destinationServiceId}
                                        onChange={(event) => {
                                            this.handleInputValueChange("destinationServiceId", event.target.value)
                                        }}
                                    />
                                     <div className="errorDesc"></div>
                                </div>
                               
                            </div>

                            <div className="form-group col-md-8 p-0 mb-1">
                                <label className="formGroup_label_new">{this.props.locales.enterAmountInCreditTransferModal}</label>
                                <div className="form-group float-left p-0" style={{ width: 64 }}>
                                    <input className="form-control formGroup_value_ mandatoryField_ input_data_" style={{textAlign: 'center', borderLeft: '3px solid #EE3124', borderTopRightRadius: 0, borderBottomRightRadius: 0, backgroundColor: '#eaedf0' }}
                                        value={Constants.dollarSign} disabled />
                                </div>
                                <div className="d-flex flex-column form-group">
                                    <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data typeVasAmount"
                                        value={this.state.amount}
                                        onChange={(event) => {
                                            this.handleInputValueChange("amount", event.target.value)
                                        }}
                                    />
                                     <div className="errorDesc"></div>
                                </div>
                               
                            </div>
                        </div>
                    </div>

                </SliderModal>

        </div>
        )
        
    }

    generalBtnClicked = (type) => {
        if(type === "creditRequest"){
            if(this.state.currentPrepaidStatus && this.state.currentPrepaidStatus !== "" && this.state.currentPrepaidStatus.toUpperCase() === "ACTIVE"){
                var allowedCreditRequestDailyCount = this.props.configurationValues.allowedCreditRequestDailyCount;
                if(parseInt(this.state.creditRequestDailyCount) <= parseInt(allowedCreditRequestDailyCount)){
                    this.setState({isCreditRequestModalVisible: true})
                } else {
                    Swal.fire(this.props.locales.creditRequestDailyCountErrSwalMsg)
                }
            } else {
                Swal.fire(this.props.locales.currentServiceNotInActiveStateSwalMsg)
            }
        } else if(type === "creditTransfer") {
                var currentStatus = "NA";
                if(this.state.connectionType === "1") currentStatus = this.state.serviceStatus;
                else currentStatus = this.state.currentPrepaidStatus;
                if(currentStatus && currentStatus !== "" && currentStatus.toUpperCase() === "ACTIVE"){
                    var allowedBalanceTransferDailyCount = this.props.configurationValues.allowedBalanceTransferDailyCount;
                    if(parseInt(this.state.balanceTransferDailyCount) <= parseInt(allowedBalanceTransferDailyCount)){
                        this.setState({isCreditTransferModalVisible: true})
                    } else {
                        Swal.fire(this.props.locales.balanceTransferDailyCountErrSwalMsg)
                    }
                } else {
                    Swal.fire(this.props.locales.currentServiceNotInActiveStateSwalMsg)
                }
           
        } else if(type === "callMeBack") {
            if(this.state.currentPrepaidStatus && this.state.currentPrepaidStatus !== "" && this.state.currentPrepaidStatus.toUpperCase() === "ACTIVE"){
                var allowedCallMeBackDailyCount = this.props.configurationValues.allowedCallMeBackDailyCount;
                console.log("allowedCallMeBackDailyCount",allowedCallMeBackDailyCount)
                console.log("this.state.callMeBackDailyCount",this.state.callMeBackDailyCount)
                if(parseInt(this.state.callMeBackDailyCount) <= parseInt(allowedCallMeBackDailyCount)){
                    console.log("hhhhh")
                    this.setState({isCallMeBackModalVisible: true})
                } else {
                    Swal.fire(this.props.locales.callMeBackDailyCountErrSwalMsg)
                }
            } else {
                Swal.fire(this.props.locales.currentServiceNotInActiveStateSwalMsg)
            }
           
        }
    }


    addonCard() {
        return <div className='cardOuterContainer p-3' >
            <div className='d-flex justify-content-between py-2' style={{flex:1}}>
                <div className='mx-1 p-2 rechargeCardTopMiniCardActive'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="59" viewBox="0 0 30 59">
                        <path id="Path_2629" data-name="Path 2629" d="M109.01,284.077A3.053,3.053,0,0,0,105.988,281H82.032a3.053,3.053,0,0,0-3.022,3.077v52.846A3.053,3.053,0,0,0,82.032,340h23.957a3.053,3.053,0,0,0,3.022-3.077Zm-5.423-1.749a.906.906,0,1,1-.89.906A.9.9,0,0,1,103.587,282.328Zm-13.349,1.834h9.076c.207,0,.383.316.383.527s-.166.527-.383.527H90.238c-.207,0-.383-.316-.383-.527S90.021,284.161,90.238,284.161Zm3.9,51.845a3.288,3.288,0,1,1,3.229-3.288A3.263,3.263,0,0,1,94.139,336.006Zm12.8-6.533H82.1v-41.1H106.94Z" transform="translate(-79.01 -281)" fill="#fff"/>
                    </svg>
                    <div className='rechargeCardTopMiniCardText'>Mobile</div>
                </div>
                <div className='mx-1 p-2 rechargeCardTopMiniCardInactive'>
                <div className='rechargeCardTopMiniCardText'>{this.props.locales.forgetPswPageUserNamePlc}</div>
                    <div className='rechargeCardTopMiniCardText' style={{fontWeight: 600}}>{this.props.cache.serviceInfo.serviceId}</div>
                </div>
                {/* <div className='mx-1 p-2 rechargeCardTopMiniCardInactive'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="54" viewBox="0 0 40 54">
                        <path id="Path_2708" data-name="Path 2708" d="M199.109,315.562a20.01,20.01,0,1,0-28.1,0,19.709,19.709,0,0,0,12.416,5.791v5.257H178.58v2.91H171.8v5.82h26.169v-5.82H191.18v-2.91H187.3v-5.325a19.088,19.088,0,0,0,11.815-5.713Zm-2.016-2.086a17,17,0,0,1-6.058,3.87,16.627,16.627,0,0,0,1.153-2.173,23.122,23.122,0,0,0,1.619-5.063h5.941A31.863,31.863,0,0,1,197.093,313.476Zm-18.2-6.276a44.457,44.457,0,0,1-.388-5.82,42.839,42.839,0,0,1,.388-5.82h12.377a44.995,44.995,0,0,1,0,11.64Zm23.174-5.82a19.54,19.54,0,0,1-.921,5.82H194.33a47.406,47.406,0,0,0,0-11.64h6.814A19.539,19.539,0,0,1,202.065,301.38Zm-4.972-12.1a31.86,31.86,0,0,1,2.656,3.366h-5.941c-.378-.97-.9-3.414-1.619-5.044a17.869,17.869,0,0,0-1.153-2.221,17.049,17.049,0,0,1,6.058,3.909Zm-16.341-.466c.7-1.6,2.268-4.472,4.332-4.472s3.635,2.862,4.332,4.452c.543,1.251.96,2.881,1.279,3.851H179.472c.32-.97.737-2.58,1.279-3.832Zm-7.686.466a17,17,0,0,1,6.058-3.87,16.639,16.639,0,0,0-1.153,2.173c-.717,1.63-1.231,4.093-1.619,5.063H170.41A31.856,31.856,0,0,1,173.066,289.284Zm-4.972,12.1a19.538,19.538,0,0,1,.921-5.82h6.814a47.406,47.406,0,0,0,0,11.64h-6.814A19.538,19.538,0,0,1,168.093,301.38Zm4.972,12.1a31.867,31.867,0,0,1-2.656-3.366h5.941a22.694,22.694,0,0,0,1.619,5.054,17.877,17.877,0,0,0,1.153,2.221A17.049,17.049,0,0,1,173.066,313.476Zm7.686.475c-.543-1.251-.96-2.862-1.279-3.832H190.7c-.32.97-.737,2.58-1.279,3.832-.7,1.591-2.268,4.51-4.332,4.51s-3.635-2.92-4.332-4.51Z" transform="translate(-165.05 -281.34)" fill="#fff" fill-rule="evenodd"/>
                    </svg>
                    <div className='rechargeCardTopMiniCardText'>Broadband</div>
                </div> */}
                {/* <div className='mx-1 p-2 rechargeCardTopMiniCardInactive'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                        <g id="Group_3413" data-name="Group 3413" transform="translate(-311.156 -373.059)">
                            <g id="Group_3408" data-name="Group 3408" transform="translate(311.156 373.059)">
                            <path id="Path_2703" data-name="Path 2703" d="M295.54,315.822a26.861,26.861,0,0,0-2.844-8.139,16.149,16.149,0,0,0-6.467-6.461c-.322-.173-.643-.363-.973-.528a1.241,1.241,0,0,1-.736-1.254c.017-1.2-.042-2.4-.025-3.607a2.147,2.147,0,0,0-1.143-2.033,9.5,9.5,0,0,0-1.718-.744,15.281,15.281,0,0,0-4.808-.536,14.6,14.6,0,0,0-4.994.753,9.447,9.447,0,0,0-1.49.709,1.927,1.927,0,0,0-1.007,1.86c.034.865-.009,1.73-.025,2.595,0,.415-.017.83-.025,1.237a.981.981,0,0,1-.559.9c-.364.182-.719.381-1.083.562a14.961,14.961,0,0,0-6.077,5.579,23.078,23.078,0,0,0-2.582,5.96,47.328,47.328,0,0,0-1.532,12.04,2.614,2.614,0,0,0,1.49,2.543,6.186,6.186,0,0,0,2.209.666c.212.026.415.086.652.138.034.424.034.8.1,1.168a2.958,2.958,0,0,0,4.562,2.119,2.9,2.9,0,0,0,1.312-2.119c.051-.4-.051-.839.245-1.185.855-.138,16.844-.147,17.9-.017a1.512,1.512,0,0,1,.144.268c.034.225.042.45.068.666a5.062,5.062,0,0,0,.161.882,2.915,2.915,0,0,0,3.25,1.929,2.983,2.983,0,0,0,2.489-2.638c.042-.363-.076-.761.2-1.133.178-.026.389-.061.6-.1a6.867,6.867,0,0,0,2-.614,2.484,2.484,0,0,0,1.532-2.5v-.337a50,50,0,0,0-.8-8.632Zm-7.686,1a4.367,4.367,0,0,1-.237.631c-.025.061-.1.1-.254.234a6.308,6.308,0,0,0-.728-.311,5.121,5.121,0,0,0-1.287-.242,1.679,1.679,0,0,0-1.5,2.534,3.47,3.47,0,0,0,.762.943,6.167,6.167,0,0,0,.762.562,3.342,3.342,0,0,1-.364.562,11.363,11.363,0,0,1-19.358-5.64,11.734,11.734,0,0,1,8.329-13.891,11.478,11.478,0,0,1,14.06,8.823,11.793,11.793,0,0,1-.195,5.8Z" transform="translate(-252.545 -283.83)" fill="#fff"/>
                            <path id="Path_2704" data-name="Path 2704" d="M299.365,290.655c-.654-2.093-.782-2.327-2.635-3.373a44.078,44.078,0,0,0-18.137-5.743,36.334,36.334,0,0,0-7.513.121,38.439,38.439,0,0,0-7.02,1.548,42.57,42.57,0,0,0-10.335,4.818,3.158,3.158,0,0,0-1.411,1.929,18.453,18.453,0,0,0-.535,4.576,1.755,1.755,0,0,0,.178.51c4.309-1.168,8.541-2.31,12.833-3.469.077-.294.119-.476.161-.649a1.707,1.707,0,0,1,1.19-1.228c.178-.061.348-.112.527-.173a27.631,27.631,0,0,1,7.411-1.22,39.827,39.827,0,0,1,4.87.147,65.106,65.106,0,0,1,7.539,1.194,3.071,3.071,0,0,1,.833.285,1.288,1.288,0,0,1,.756,1.375c-.026.216-.034.432-.06.727q5.507,1.635,10.955,3.235a4,4,0,0,0,.62.1c.068-.112.127-.173.136-.242a12.361,12.361,0,0,0-.348-4.463Z" transform="translate(-251.78 -281.4)" fill="#fff"/>
                            </g>
                            <path id="Path_2705" data-name="Path 2705" d="M264.257,299.632a5.719,5.719,0,0,0,1.306-.64,1.384,1.384,0,0,0,.675-1.444,6.645,6.645,0,0,0-.7-2.258c-4.351,1.15-8.624,2.284-12.9,3.417-.216.061-.415.156-.64.242a5.351,5.351,0,0,0,.8,2.569,1.22,1.22,0,0,0,1.116.649,7.446,7.446,0,0,0,1.453-.13c1.5-.337,3-.675,4.481-1.081s2.95-.856,4.411-1.323Z" transform="translate(59.346 89.518)" fill="#fff"/>
                            <path id="Path_2706" data-name="Path 2706" d="M293.563,295.8c-.216.874-.406,1.592-.562,2.327a1.643,1.643,0,0,0,1,2.024,5.009,5.009,0,0,0,.631.242c2.578.822,5.172,1.574,7.8,2.188a4.861,4.861,0,0,0,1.9.1.99.99,0,0,0,.813-.528,7.693,7.693,0,0,0,.761-2.707,4.079,4.079,0,0,0-.528-.251c-3.892-1.107-7.767-2.284-11.833-3.391Z" transform="translate(52.966 89.439)" fill="#fff"/>
                            <path id="Path_2707" data-name="Path 2707" d="M279.49,309.79a6.15,6.15,0,0,0-6.15,6.029,6.077,6.077,0,0,0,12.153.13,6.166,6.166,0,0,0-6.012-6.159Z" transform="translate(56.032 87.205)" fill="#fff"/>
                        </g>
                    </svg>
                    <div className='rechargeCardTopMiniCardText'>Fixed</div>
                </div> */}
            </div>
            <div style={{flex:3}}>
                <div className='dividerLine my-2'></div>

                {this.state.connectionType === "2" ?
                <div className='d-flex justify-content-between'>
                    <div className='col-md-5 m-0 p-0'>
                        <div className='brandColorButton p-1 px-2 my-1'>
                            <Link to="/Recharge" style={{ color: '#FFFFFF', textDecoration: 'none' }}>
                                Recharge
                            </Link>
                        </div>
                       
                       { this.state.enableVasFeatures === "true" ? 
                       <>
                       {this.state.balanceTransferStatus ? 
                        <div className={this.state.creditTransferAllowed ? "brandColorButton p-1 px-2 my-1" : "brandColorButton brandColorButtonDisabled p-1 px-2 my-1"} onClick={() => { this.generalBtnClicked("creditTransfer") }}>{this.props.locales.creditTransferHeading}</div> 
                        : null }

                        {this.state.creditRequestStatus ?
                        <div className={this.state.creditRequestAllowed ? "brandColorButton p-1 px-2 my-1" : "brandColorButton brandColorButtonDisabled p-1 px-2 my-1"} onClick={() => { this.generalBtnClicked("creditRequest") }}>{this.props.locales.creditRequestHeading}</div> 
                        : null }
                       {this.state.callMeBackStatus ?
                        <div className={this.state.callMeBackAllowed  ? "brandColorButton p-1 px-2 my-1" : "brandColorButton brandColorButtonDisabled p-1 px-2 my-1"} onClick={() => { this.generalBtnClicked("callMeBack") }}>{this.props.locales.callMeBackHeading}</div> 
                        : null }
                        </>
                        : null }
                        <div className='pl-2 pt-2 labelSmall' style={{fontSize: 12}}>{this.props.locales.creditExpiryDateForPrepaid}&nbsp;</div>
                        <div className='pl-2 pb-2' style={{fontSize: 14}}>{this.state.serviceExpiryDateForPrepaid}</div>
                    </div>
                    <div className='col-md-7'>
                        <div className='smallHeadPrimaryNormal'>Usage Summary</div>
                        <div className='labelHead'>Balance:</div>
                        <div className='mediumHeadPrimaryMedium'>${this.state.maBalance}</div>
                    </div>
                </div>
                
                :
                <div className='d-flex justify-content-between'>
                    <div className='col-md-5 m-0 p-0'>
                        <div className='brandColorButton p-1 px-2 my-1'>
                        <Link to="/Invoices" style={{ color: '#FFFFFF', textDecoration: 'none' }}>
                            Pay Bill
                        </Link>

                        </div>
                        { this.state.enableVasFeatures === "true" && this.state.balanceTransferStatus ? 
                             <div className={this.state.creditTransferAllowed ? "brandColorButton p-1 px-2 my-1" : "brandColorButton brandColorButtonDisabled p-1 px-2 my-1"} onClick={() => { this.generalBtnClicked("creditTransfer") }}>{this.props.locales.creditTransferHeading}</div> 
                        : null }
                    </div>
                    <div className='col-md-7'>
                        <div className='smallHeadPrimaryNormal'>Usage Summary</div>
                        <div className='labelHead'>Amount Due:</div>
                        <div className='mediumHeadPrimaryMedium'>${this.state.outstandingAmount}</div>
                        <div className='labelHead'>Due Date:</div>
                        <div className='mediumHeadPrimaryMedium'>{this.state.billDueDate}</div>
                    </div>
                </div>
                }

                {this.state.allAddonArray && this.state.allAddonArray[0] ? 
                <>
                <div className='dividerLine my-2'></div>

                <div className='col-md-12 m-0 p-0'>
                    <div className='semimediumHeadPrimaryNormal'>Additional Bundles</div>
                </div>
                </>
                : null }
                
                {this.state.allAddonArray && this.state.allAddonArray.map((addon, index) => (
                    <div key={index}>
                        {this.populateAddonUsage(addon, "firstAddon")}
                    </div>
                ))}
            </div>

        </div>
    }

    myPlanCard() {
        var benefitArr =  this.state.basePlanDetailsObj.benefits;
        if(this.state.isBaseAddonAvailable) benefitArr = this.state.baseAddonObj.benefits
        var originalBenefitsArr = [];
        if(benefitArr && benefitArr[0])
        originalBenefitsArr = [...benefitArr];
        var benefitArrNew = originalBenefitsArr.filter(benefit => benefit.isCarryForward !== "true");

        // if(this.state.basePlanDetailsObj && this.state.basePlanDetailsObj.benefits.length >= 1){
        //     benefitArr = this.state.basePlanDetailsObj.benefits.splice(1);
        // }

        var activePlanName = this.state.basePlanDetailsObj.activePlanName;
        var activePlanAmount = this.state.basePlanDetailsObj.activePlanAmount;
        var activePlanDecimal = this.state.basePlanDetailsObj.activePlanDecimal;
        var activePlanDesc = this.state.basePlanDetailsObj.activePlanDesc;
        var activationDate = this.state.basePlanDetailsObj.activationDate;
        var discountAmount = this.state.basePlanDetailsObj.discountAmount;
        var expiryDate = this.state.basePlanDetailsObj.postpaidExpiryDate;


        var benefits = this.state.basePlanDetailsObj.benefits;

        if(this.state.isBaseAddonAvailable){
            var packageAmount="0"
            var packageAmount_sup = "00"
            var Price = GeneralUtils.formatNumberToStandardForm(this.state.baseAddonObj.addonPrice,this.props.configurationValues)
            Price = Price.split(".");
            packageAmount = Price[0]
            if (Price.length > 1) {
                packageAmount_sup = Price[1];
            } else {
                packageAmount_sup = "00"
            }

            activePlanName = this.state.baseAddonObj.addonName;
            activePlanAmount = packageAmount;
            activePlanDecimal = packageAmount_sup;
            activePlanDesc = this.state.baseAddonObj.addonDesc;

            if(this.props.cache.serviceInfo.connectionType != "1"){
                activationDate =  GeneralUtils.formatDateToStandardForm(this.state.baseAddonObj.effectiveDate, this.props.configurationValues.dateFormatForBilling)
            } else {
                activationDate =  GeneralUtils.formatDateToStandardForm(this.state.baseAddonObj.activationDate, this.props.configurationValues.dateFormatForBilling)
            }
           
            expiryDate = this.state.baseAddonObj.expiryDate;
            discountAmount = 0;
            benefits=this.state.baseAddonObj.benefits;
        }

        return <div className='cardOuterContainer p-3'>
            <div className='py-2'>
                <div className='headPrimaryMedium'>My Plan Details</div>
                <div className='headMedium'>{activePlanName}</div>
            </div>
            <div className='dividerLine my-2'></div>
            <div className='d-flex justify-content-between align-items-center'>
                <div className='col-md-4 m-0 p-0'>
                    <div className='activeButtonOuterContainer p-1'>
                        <div className='activeButtonInnerContainer p-3'>{this.state.serviceStatus}</div>
                    </div>
                </div>
                <div className='col-md-7 py-2'>
                    <div className='labelSmall'>activation date:</div>
                    <div className='valueText'>{activationDate}</div>
                    {/* <div className='labelSmall'>expiry date:</div> */}
                    {/* <div className='valueText'>{expiryDate}</div> */}
                </div>
            </div>
           {benefitArrNew && benefitArrNew.length > 0 ? 
            <div className='d-flex'>
            <div className='col-md-5'>
                <div className='mediumHeadPrimaryNormal'>Plan Features </div>
            </div>
            <div className='col-md-7'>
                <div className='mediumHeadPrimaryNormal'>Details</div>
            </div>
        </div>
        : null }
            {this.populateUsage(benefitArrNew)}

        </div>
    }

    populateAddonUsage(receivedAddonObj, type) {
        // if (!receivedAddonObj || !receivedAddonObj.benefits || receivedAddonObj.benefits.length === 0) {
        //     return null; // No benefits to display
        // }
    
        //let isBenifitsAvailable = false; // Define isBenifitsAvailable here


        var addonExpiry = GeneralUtils.formatDateToStandardForm(receivedAddonObj.activationDate, this.props.configurationValues.dateFormatForBilling);
        if(this.props.cache.serviceInfo.connectionType != "1"){
            addonExpiry = GeneralUtils.formatDateToStandardForm(receivedAddonObj.effectiveDate, this.props.configurationValues.dateFormatForBilling);
        } 

       
        if(receivedAddonObj.benefits && receivedAddonObj.benefits[0]){
        return receivedAddonObj.benefits.map((item, key) => {
           // isBenifitsAvailable = true;
           const expiryDate = GeneralUtils.formatDateToStandardForm(item.expiryDate, this.props.configurationValues.dateFormatForBilling);
            const displayName = this.state.selfcareBucketNames.find(bucket => bucket.ORIGINAL_NAME.toLowerCase() === item.usageName.toLowerCase());
    
            var usageName = displayName ? displayName.DISPLAY_NAME : item.usageName;
            var used = parseFloat(item.initialVal) - parseFloat(item.val);
            var widthFromVar = ((parseFloat(used) / parseFloat(item.initialVal)) * 100);
    
            let totalVal = item.initialVal;
            let unit = item.unit;
    
            if (typeof used !== 'number' || (used % 1) !== 0) {
                used = GeneralUtils.formatNumberToStandardFormWithoutComma(used, this.props.configurationValues);
            }
    
            if(item.initialVal === "UNLIMITED" && item.val === "UNLIMITED"){
                used= "UNLIMITED";
                widthFromVar=100;
            }
            if(item.initialVal === "0" && item.val === "0") widthFromVar = 0
    
            const progressBar = (
                <div className='col-md-5 p-0'>
                    <ProgressBar
                        progress={widthFromVar}
                        radius={50}
                        strokeWidth={10}
                        strokeColor={'#D3232A'}
                        trackStrokeWidth={10}
                        trackStrokeColor={'#2073B7'}
                        pointerRadius={10}
                        pointerStrokeWidth={5}
                        strokeLinecap={'square'}
                        pointerStrokeColor={'#EEC21B99'}
                        pointerFillColor={'#AD1E22'}
                        className='your-indicator'
                        children={
                            <div style={{ position: "absolute", alignSelf: "center" }}>
                                <div className='percentTxt'>{used}</div>
                                <div className='percentDecTxt'>of</div>
                                <div className='percentDecTxt'>{totalVal} {unit}</div>
                                <div className='percentDecTxt'>Used</div>
                            </div>
                        }
                    />
                </div>
            );
    
            return (
                <div className='d-flex flex-column' key={key}>
                   
                    <div className='col-md-12 row mx-auto p-0 pb-3'>
                    {key == 0 ?
                    <>
                        <div className='py-1 col-md-12 p-0'>
                            <div className='labelSmall' style={{ color: '#2173B8', fontWeight: 'bold' }}>{receivedAddonObj.addonName}</div>
                            {/* <div className='labelSmall'>{receivedAddonObj.addonDesc}</div> */}
                        </div>
                        <div className='py-1 col-md-12 p-0'>
                            <div className='labelSmall'>Activated on</div>
                            <div className='valueText'>{addonExpiry}</div>
                        </div>
                        </>
                        : null }
                        
                            <div className='col-md-12 row m-0 p-0'>
                                {progressBar}
                                <div className='col-md-7'>
                                    <div className='py-1'>
                                        <div className='labelHead' style={{wordBreak: 'break-word'}}>{usageName}</div>
                                    </div>
                                    {item.isCarryForward === "true" ?
                                        <div className="pb-1" style={{ color: '#231F20', fontWeight: 500, fontSize: 11 }}>{this.props.locales.carryForwardLabel}</div>
                                        : null}
                                    <div className='py-1'>
                                        <div className='labelSmall'>Expire on</div>
                                        <div className='valueText'>{expiryDate}</div>
                                    </div>
                                </div>
                            </div>
                            
                    </div>
                </div>
            );
        });
    } else {
        return(
            <>
             <div className='py-1 col-md-12 p-0'>
                    <div className='labelSmall' style={{ color: '#2173B8', fontWeight: 'bold' }}>{receivedAddonObj.addonName}</div>
                    {/* <div className='labelSmall'>{receivedAddonObj.addonDesc}</div> */}
                </div>
                <div className='py-1 col-md-12 p-0'>
                    <div className='labelSmall'>Activated on</div>
                    <div className='valueText'>{addonExpiry}</div>
                </div>
                <div style={{color: '#eb4034'}}>No bundles found</div>
            </>
           
        )
    }
    }
    

    populateUsage(benefitsArr){
        const allUsage = benefitsArr.map((item, key) => {
          
            //display bucket name from config
            //display bucket name from config
            var usageName = item.usageName;
            const displayName = this.state.selfcareBucketNames.find(item => 
                item.ORIGINAL_NAME.toLowerCase() === usageName.toLowerCase()
               );
            if (displayName) {
                const newName = displayName.DISPLAY_NAME;
                usageName = newName
            } 

            var expiryDate = GeneralUtils.formatDateToStandardForm(item.expiryDate, this.props.configurationValues.dateFormatForBilling)

            var widthFromVar = 0;
            var used = 0;
            
                used = parseFloat(item.initialVal) - parseFloat(item.val)
                widthFromVar = ((parseFloat(used) / parseFloat(item.initialVal)) * 100)
                if(typeof used === 'number' && (used % 1) === 0) {
                    // data is an integer
                } else {
                    used = GeneralUtils.formatNumberToStandardFormWithoutComma(used,this.props.configurationValues)
                }
               
                if(item.initialVal === "UNLIMITED" && item.val === "UNLIMITED"){
                    used= "UNLIMITED";
                    widthFromVar=100;
                }
                if(item.initialVal === "0" && item.val === "0") widthFromVar = 0
            return(
                <>
                <div className='col-md-12 row m-0 p-0 mb-4'>
                <div className='col-md-5 p-0'> 
                <div>
                        <ProgressBar
                                progress={widthFromVar}
                                radius={50}
                                strokeWidth={10}
                                strokeColor={'#D3232A'}
                                trackStrokeWidth={10}
                                trackStrokeColor={'#2073B7'}
                                pointerRadius={10}
                                pointerStrokeWidth={5}
                                strokeLinecap={'square'}
                                pointerStrokeColor={'#EEC21B99'}
                                pointerFillColor={'#AD1E22'}
                                className='your-indicator'
                                children={<div style={{position:"absolute",alignSelf:"center"}}>
                                    <div className='percentTxt'>{used}</div> 
                                    <div className='percentDecTxt'>of</div>
                                    <div className='percentDecTxt'>{item.initialVal} {item.unit}</div>
                                    <div className='percentDecTxt'>Used</div>
                                </div>}
                            />
                        </div>
                </div>
                <div className='col-md-7'>
                    <div className='py-1'>
                        
                        <div className='labelSmall' style={{wordBreak: 'break-word'}}>{usageName}</div>
                    </div>
                    {/* {item.isCarryForward === "true" ? 
                    <div className="pb-1" style={{color: '#231F20', fontWeight: 500, fontSize: 11}}>{this.props.locales.carryForwardLabel}</div>
                    : null } */}

                    <div className='py-1'>
                        <div className='labelSmall'>Expire on</div>
                        <div className='valueText'>{expiryDate}</div>
                    </div>
                    
                    
                </div>
            </div>
            </>
            )
        })
        return (allUsage)

    }

    moreFeturesCard() {
        var benefitArr = this.state.basePlanDetailsObj.benefits;
        if(this.state.isBaseAddonAvailable) benefitArr = this.state.baseAddonObj.benefits

        var originalBenefitsArr = [];
        if(benefitArr && benefitArr[0])
        originalBenefitsArr = [...benefitArr];
        var benefitArrNew = originalBenefitsArr.filter(benefit => benefit.isCarryForward === "true");
        if(benefitArrNew && benefitArrNew.length > 0){
            return (
                <div className='cardOuterContainer p-3'>
                      <div className='py-2'>
                <div className='headPrimaryMedium'>{this.props.locales.rollOverBundlesMainHeading}</div>
                {/* <div className='headMedium'>{activePlanName}</div> */}
            </div>
            <div className='dividerLine my-2'></div>
                    <div className='col-md-12 row p-0 m-0 pt-3'>
                      {this.populateUsage(benefitArrNew)}
                    </div>
                    <div className='my-4'></div>
                </div>
              );
        }
      }
       
       

        // commenting base plan usage
        // if(this.state.basePlanDetailsObj && this.state.basePlanDetailsObj.benefits.length > 1){
        //     var benefitArr = this.state.basePlanDetailsObj.shift();
        //     this.populateUsage(benefitArr)
        // }
        // return <div className='cardOuterContainer p-3'>
        //     <div className='d-flex justify-content-center'>
        //         <div className='headPrimaryMedium'>More Features</div>
        //     </div>
        //     <div className='d-flex'>
        //         <div className='col-md-5'>
        //             <div className='mediumHeadPrimaryNormal'>Plan Features </div>
        //         </div>
        //         <div className='col-md-7'>
        //             <div className='mediumHeadPrimaryNormal'>Details</div>
        //         </div>
        //     </div>
        //     <div className='d-flex py-3'>
        //         <div className='col-md-5'> 
        //         <div>
        //         <ProgressBar
        //                         progress={60}
        //                         radius={50}
        //                         strokeWidth={10}
        //                         strokeColor={'#D3232A'}
        //                         trackStrokeWidth={10}
        //                         trackStrokeColor={'#2073B7'}
        //                         pointerRadius={10}
        //                         pointerStrokeWidth={5}
        //                         strokeLinecap={'square'}
        //                         pointerStrokeColor={'#EEC21B99'}
        //                         pointerFillColor={'#AD1E22'}
        //                         className='your-indicator'
        //                         children={<div style={{position:"absolute",alignSelf:"center"}}>
        //                             <div className='percentTxt'>51%</div> 
        //                             <div className='percentDecTxt'>of</div>
        //                             <div className='percentDecTxt'>200 Mins</div>
        //                             <div className='percentDecTxt'>Used</div>
        //                         </div>}
        //                     />
                       
        //                 </div>
        //         </div>
        //         <div className='col-md-7 align-content-center'>
        //             <div className='py-1'>
        //                 <div className='labelSmall'>Prepaid</div>
        //                 <div className='labelSmall'>data</div>
        //             </div>
        //             <div className='py-1'>
        //                 <div className='labelSmall'>Expire on</div>
        //                 <div className='valueText'>2022-11-14</div>
        //             </div>
                    
                    
        //         </div>
        //     </div>
        //     <div className='d-flex py-3'>
        //         <div className='col-md-5'> 
        //         <div>
        //                 <ProgressBar
        //                         progress={60}
        //                         radius={50}
        //                         strokeWidth={10}
        //                         strokeColor={'#D3232A'}
        //                         trackStrokeWidth={10}
        //                         trackStrokeColor={'#2073B7'}
        //                         pointerRadius={10}
        //                         pointerStrokeWidth={5}
        //                         strokeLinecap={'square'}
        //                         pointerStrokeColor={'#EEC21B99'}
        //                         pointerFillColor={'#AD1E22'}
        //                         className='your-indicator'
        //                         children={<div style={{position:"absolute",alignSelf:"center"}}>
        //                             <div className='percentTxt'>51%</div> 
        //                             <div className='percentDecTxt'>of</div>
        //                             <div className='percentDecTxt'>200 Mins</div>
        //                             <div className='percentDecTxt'>Used</div>
        //                         </div>}
        //                     />
                       
        //                 </div>
        //         </div>
        //         <div className='col-md-7'>
        //             <div className='py-1'>
        //                 <div className='labelSmall'>Prepaid</div>
        //                 <div className='labelSmall'>data</div>
        //             </div>
        //             <div className='py-1'>
        //                 <div className='labelSmall'>Expire on</div>
        //                 <div className='valueText'>2022-11-14</div>
        //             </div>
                    
                    
        //         </div>
        //     </div>

        // </div>
    
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        },
        setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        },
    }
}

const HomeComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(HomeComponent)

export default HomeComponentContainer;
